'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function FirstClassPreparationPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-6 xxs:py-3 px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-gradient-to-b from-blue-50 to-white'
        : 'bg-gradient-to-b from-gray-900 to-gray-800'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link href="/guide" className={`hover:underline mb-3 xxs:mb-2 inline-block text-sm xxs:text-xs ${
          theme === 'light' ? 'text-blue-600' : 'text-blue-400'
        }`}>
          ← 입문 가이드 목록
        </Link>

        <article className={`rounded-lg shadow-xl p-6 xxs:p-3 ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <h1 className={`text-2xl xxs:text-lg font-bold mb-4 xxs:mb-3 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>첫 강습 준비물</h1>

          <div className="max-w-none">
            <p className={`text-sm xxs:text-xs mb-4 xxs:mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              프리다이빙 강습을 처음 받으실 때 필요한 준비물과 팁을 안내해드립니다.
            </p>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>필수 준비물</h2>
            <div className="space-y-3 xxs:space-y-2">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>1. 수영복</h3>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 몸에 잘 맞는 수영복 (원피스 또는 투피스)<br />
                  • 너무 헐렁하면 물 저항이 커집니다<br />
                  • 래쉬가드도 좋은 선택입니다
                </p>
              </div>

              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>2. 수건 & 세면도구</h3>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 샤워 후 사용할 수건<br />
                  • 샴푸, 바디워시 등 세면도구<br />
                  • 여분의 옷가지
                </p>
              </div>

              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h3 className={`font-bold text-sm xxs:text-xs mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>3. 귀마개 (선택)</h3>
                <p className={`text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  • 귀가 민감하신 분들께 추천<br />
                  • 수영용 귀마개 사용<br />
                  • 프리다이빙 전용 귀마개도 있습니다
                </p>
              </div>
            </div>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>센터에서 제공하는 장비</h2>
            <ul className={`space-y-1.5 xxs:space-y-1 text-xs xxs:text-[10px] ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              <li>✅ 마스크 (다이빙 고글)</li>
              <li>✅ 스노클</li>
              <li>✅ 핀 (오리발)</li>
              <li>✅ 웨이트벨트 (필요시)</li>
              <li>✅ 웻슈트 (센터에 따라 다름)</li>
            </ul>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-yellow-50' : 'bg-yellow-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>💡 강습 전 주의사항</h3>
              <ul className={`text-xs xxs:text-[10px] space-y-1.5 xxs:space-y-1 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                <li>• 강습 2시간 전에는 식사를 마쳐주세요</li>
                <li>• 전날 충분한 수면을 취하세요</li>
                <li>• 음주 후 24시간 이내 강습은 금지입니다</li>
                <li>• 감기나 중이염이 있으면 강습을 미루세요</li>
                <li>• 편안한 마음으로 참여하세요!</li>
              </ul>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>강습 센터 찾기</h3>
              <p className={`text-xs xxs:text-[10px] mb-3 xxs:mb-2 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                가까운 다이빙풀을 찾아 강습을 예약해보세요!
              </p>
              <Link
                href="/map"
                className="inline-block px-4 xxs:px-3 py-2 xxs:py-1.5 text-xs xxs:text-[10px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                전국 다이빙풀 찾기
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
